import React from 'react';
import { compose, pure } from 'recompose';
import { Track } from 'angieslist-app-platform';
import MessageModalConfig from './data/MessageModalConfig';
import MessageModal from './MessageModal';
import './EstimatedLeads.scss';
import { ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL } from '../../../../common/commonConstants';

type Props = {
  value: number;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  estimates: any;
  premiumUrl: string;
  onlineUpgradeOffer: string;
};

/**
 * A component to show the EstimatedLeads for LeadsCalculator
 * @returns {Node}
 * @example
 * <EstimatedLeads value={300} />
 */
const EstimatedLeads = ({
  value,
  showModal,
  setShowModal,
  estimates,
  premiumUrl,
  onlineUpgradeOffer,
}: Props): Node => (
  <div
    className="estimated-leads-container"
  >
    <div className="estimated-leads-header">
        ESTIMATED LEADS
    </div>
    <div
      className="estimated-leads-amount-wrapper"
    >
      <div className="estimated-leads-amount National2-Bold">
        {estimates[value].lowLeadsEstimate} - {estimates[value].highLeadsEstimate}{' '}
        <span className="whitespace-pre">per month</span>
      </div>
    </div>

    <div className="estimate-button-wrapper">
      <Track>
        <button
          id="learn-more-about-premium--leads-calculator"
          className="learn-about-premium-button"
          onClick={() => {
              window.location.href = premiumUrl;
            }}
        >
          {onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL ? 'Try 1 month free' : 'Learn about Angi Ads'}
        </button>
      </Track>
      <Track>
        <button
          id="how-we-estimate-button--leads-calculator"
          className="how-we-estimate-button"
          onClick={() => {
              setShowModal(true);
            }}
        >
            How we estimate your leads
        </button>
      </Track>
    </div>
    <MessageModal
      open={showModal}
      onClose={() => setShowModal(false)}
      header={MessageModalConfig().messageModal.header}
      description={MessageModalConfig().messageModal.description}
      buttonText={MessageModalConfig().messageModal['button-text']}
    />
  </div>
);

export default (compose(pure)(EstimatedLeads): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/EstimatedLeads.js